import { getAxiosClientWithToken } from './index';

export const getDashboardata = () => {
    const restClient = getAxiosClientWithToken();
    return restClient.get('/admin/dashboard');
};
